export default import.meta.ROLLUP_FILE_URL_yQ5Mw_tp$C5jgqb_o_VSHg;